module.exports = __webpack_public_path__ + "static/media/8OLA2.8a526d8d.jpg";